module.exports = __webpack_public_path__ + "static/media/fraction-division.cf2b7312.svg";